<div class="chef-modal-header modal-header border-0 text-center age-modal-header">
    <h3 class="mb-0 w-100 chef-modal-title" id="ageModal">Please help us know who to share our food with by selecting your age range from the choices below!</h3>
    <button type="button" class="btn-close btn-sm float-end" aria-describedby="ageModal" aria-label="Close" aria-hidden="true" (click)="closeModal()"></button>
</div>
<div class="chef-modal-body modal-body text-center">
    <lib-chef-message [options]="messageOptions"></lib-chef-message>
    <form class="mb-0" name="ageUpdateForm" [formGroup]="ageUpdateForm" (ngSubmit)="onSubmit()">
        <div class="text-start">
            <div class="radio-wrapper">
                <input id="radio-1" class="radio-style" type="radio" value="18-24" formControlName="ageRange" >
                <label for="radio-1" class="radio-style-2-label">18-24</label>
            </div>
            <div class="radio-wrapper">
                <input id="radio-2" class="radio-style" type="radio" value="25-29" formControlName="ageRange" >
                <label for="radio-2" class="radio-style-2-label">25-29</label>
            </div>
            <div class="radio-wrapper">
                <input id="radio-3" class="radio-style" type="radio" value="30-34" formControlName="ageRange" >
                <label for="radio-3" class="radio-style-2-label">30-34</label>
            </div>
            <div class="radio-wrapper">
                <input id="radio-4" class="radio-style" type="radio" value="35-44" formControlName="ageRange" >
                <label for="radio-4" class="radio-style-2-label">35-44</label>
            </div>
            <div class="radio-wrapper">
                <input id="radio-5" class="radio-style" type="radio" value="45-54" formControlName="ageRange" >
                <label for="radio-5" class="radio-style-2-label">45-54</label>
            </div>
            <div class="radio-wrapper">
                <input id="radio-6" class="radio-style" type="radio" value="55-64" formControlName="ageRange" >
                <label for="radio-6" class="radio-style-2-label">55-64</label>
            </div>
            <div class="radio-wrapper">
                <input id="radio-7" class="radio-style" type="radio" value="65+" formControlName="ageRange" >
                <label for="radio-7" class="radio-style-2-label">65+</label>
            </div>
            <span class="error-text">{{errorObj['ageRange']}}</span>
        </div>
        <div class="btn-group-justified btn-group-sm btn-group-vertical mt-2 mt-lg-4">
            <button type="submit" class="button button-rounded button-green w-100 nott">Submit</button>
        </div>
    </form>
</div>
